var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.mapsMode
    ? _c(
        "div",
        {
          staticClass:
            "d-flex flex-column justify-content-center align-items-center",
          staticStyle: { gap: "5px" },
        },
        [
          _c("MMP_LatLong", {
            attrs: {
              map: _vm.map,
              mapsMode: _vm.mapsMode,
              clickedCoords: _vm.clickedCoords,
              selectedExtent: _vm.selectedExtent,
            },
            on: {
              addPoint: function ($event) {
                return _vm.$emit("addPoint", $event)
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }